import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FooterComponent } from 'app/components/footer/footer.component';
import { HeaderComponent } from 'app/components/header/header.component';
import { InputGeneralComponent } from 'app/components/input-general/input-general.component';
import { SelectGeneralComponent } from 'app/components/select-general/select-general.component';
import { News } from '../home/home.types';
import {
    ActivatedRoute,
    RouterModule,
} from '@angular/router';
import moment from 'moment';
import { CommonModule, DatePipe } from '@angular/common';
import { DateAgoPipe } from 'app/core/pipes/date-ago.pipe';
import { HomePageService } from '../home/home.service';

@Component({
    selector: 'app-blog-details',
    templateUrl: './blog-details.component.html',
    imports: [
        HeaderComponent,
        FooterComponent,
        InputGeneralComponent,
        SelectGeneralComponent,
        TranslateModule,
        CommonModule,
        RouterModule,
    ],
    standalone: true,
    styles: [
        `
            :host {
                width: 100%;
            }
        `,
    ],
})
export class BlogDetailsComponent {
    newsDetailsArr: any;
    showNews: News[];
    showMainNews;
    showSubNews;
    timeAgo;
    showMainNewsTimeAgo;
    newsId: any;
    newsHighlightsData: any;
    showNewsHighlights: any;
    clickedOutside: boolean = false;

    constructor(
        public datepipe: DatePipe,
        private homepageService: HomePageService,
        private activatedRoute: ActivatedRoute,
    ) {
        this.activatedRoute.params.subscribe((params) => {
            this.newsId = params['id'];
            this.getNewsById(this.newsId);
        });
    }

    ngOnInit() {
        this.newsId = this.activatedRoute.snapshot.paramMap.get('id');

        //Get specific news
        this.getNewsById(this.newsId);

        //Get All news to highlight
        this.getHighlights();
    }

    getNewsById(newsId) {
        this.homepageService.getNewsHome(newsId).subscribe((data: any) => {
            if (data?.detail?.length > 0) {
                this.newsDetailsArr = data.detail;
                this.newsDetailsArr.forEach((element) => {
                    element.timestamp = this.calculateTimeAgo(
                        element.timestamp,
                    );
                });
            }
        });
    }

    getHighlights() {
        this.homepageService.getNewsHome().subscribe((data: any) => {
            if (data?.length > 0) {
                this.newsHighlightsData = data;

                const getHighlightedNews = this.newsHighlightsData.filter(
                    (item: any) => {
                        return item;
                    },
                );

                const highlightedNewsArr = getHighlightedNews.slice(0, 4);

                highlightedNewsArr.forEach((element: any) => {
                    element.timestamp = this.calculateTimeAgo(
                        element.timestamp,
                    );
                });

                highlightedNewsArr.sort(
                    (a, b) => Number(a.newsHighlight) - Number(b.newsHighlight),
                );

                this.showNewsHighlights = highlightedNewsArr;
            }
        });
    }

    calculateTimeAgo(timeValue) {
        let startDate: any = new Date(timeValue);

        let dateAgoPipe = new DateAgoPipe();

        let dateToCompare = moment(startDate, 'DDMMYYYY');
        let today = moment().startOf('day'); // At midnight earlier today

        if (dateToCompare < today) {
            let date = this.datepipe.transform(startDate, 'dd/MM/yyyy');
            return (timeValue = date);
        } else {
            let date = dateAgoPipe.transform(startDate);
            return (timeValue = date);
        }
    }

    changeMenuCondition(event: any) {
        this.clickedOutside = false;
    }

    closeMegaMenuCondition() {
        this.clickedOutside = !this.clickedOutside;
    }
}
